<script>
    export default {
        props: {
            tableId: {
                required: true
            },
            initConnectionTypeId: {
                type: String,
                required: true
            },
            initName: {
                type: String,
                required: true
            },
            existingMetadata: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                connectionTypeId: this.initConnectionTypeId,
                tableName: this.initName,
            };
        },
        computed: {
            existedMetadata() {
                return this.existingMetadata.filter(item => {
                    if (parseInt(item.id) === parseInt(this.tableId)) {
                        return false;
                    }

                    return parseInt(item.connection_type_id) === parseInt(this.connectionTypeId) &&
                        item.name === this.tableName;
                })[0];
            },
        }
    };
</script>
